import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1468.23529,1355.29412 L1581.17647,1355.29412 L1581.17647,1016.47059 L1468.23529,1016.47059 L1468.23529,1355.29412 Z M1468.23529,1581.17647 L1581.17647,1581.17647 L1581.17647,1468.23529 L1468.23529,1468.23529 L1468.23529,1581.17647 Z M1524.70588,903.529412 C1742.68235,903.529412 1920,1080.84706 1920,1298.82353 C1920,1516.8 1742.68235,1694.11765 1524.70588,1694.11765 C1306.72941,1694.11765 1129.41176,1516.8 1129.41176,1298.82353 C1129.41176,1080.84706 1306.72941,903.529412 1524.70588,903.529412 Z M677.647059,1242.35294 L677.647059,1355.29412 L338.823529,1355.29412 L338.823529,1242.35294 L677.647059,1242.35294 Z M903.529412,1016.47059 L903.529412,1129.41176 L338.823529,1129.41176 L338.823529,1016.47059 L903.529412,1016.47059 Z M1129.41176,338.823529 L1129.41176,790.588235 L338.823529,790.588235 L338.823529,338.823529 L1129.41176,338.823529 Z M1016.47059,1298.82353 C1016.47059,1037.92941 1214.79529,824.809412 1468.23529,796.348235 L1468.23529,0 L0,0 L0,1920 L1468.23529,1920 L1468.23529,1801.29882 C1214.79529,1772.83765 1016.47059,1559.71765 1016.47059,1298.82353 L1016.47059,1298.82353 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconNotGradedSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconNotGradedSolid, _Component);

  var _super = _createSuper(IconNotGradedSolid);

  function IconNotGradedSolid() {
    _classCallCheck(this, IconNotGradedSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconNotGradedSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconNotGraded",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconNotGradedSolid.displayName = "IconNotGradedSolid";
  return IconNotGradedSolid;
}(Component);

IconNotGradedSolid.glyphName = 'not-graded';
IconNotGradedSolid.variant = 'Solid';
IconNotGradedSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconNotGradedSolid;
export { IconNotGradedSolid };